import { useTranslation } from "react-i18next"

import Tab from "@/components/tab/Tab"
import { createActivityCommonStore } from "@/app/activity/store"
import type { ActivityViewMode } from "@/app/activity/store/activityCommonStore"

const OPTIONS: { value: ActivityViewMode; labelKey: string; fallback: string }[] = [
  { value: "month", labelKey: "calendarView.monthly", fallback: "Month" },
  { value: "week", labelKey: "calendarView.weekly", fallback: "Week" },
  { value: "schedule", labelKey: "calendarView.daily", fallback: "Schedule" },
]

export default function ActivityViewToggle() {
  const { t } = useTranslation()
  const { viewMode, setViewMode } = createActivityCommonStore((state) => ({
    viewMode: state.viewMode,
    setViewMode: state.setViewMode,
  }))

  return (
    <Tab
      type="filled"
      list={OPTIONS.map((opt) => ({
        value: opt.value,
        label: t(opt.labelKey, opt.fallback),
      }))}
      value={viewMode}
      onChange={(_, newValue) => setViewMode(newValue as ActivityViewMode)}
    />
  )
}
